/* eslint-disable @next/next/no-img-element */
import { observer } from "mobx-react"
import parse from "react-html-parser"
import { useStore } from "@features/common"
import { BreakPoints } from "styles/styles"

import HeroSectionBg from "./hero-section-bg.png"
import HeroSectionBgMobile from "./hero-section-bg-mobile.png"
import HeroSectionBottomBg from "./hero-section-bottom-bg.svg"
import HeroSectionBottomBgMobile from "./hero-section-bottom-bg-mobile.svg"
import HeroSectionIllustration from "./hero-section-illustration.png"
import HeroSectionIllustrationMobile from "./hero-section-illustration-mobile.png"

const Hero = () => {
  const {
    ResponsiveModel: { width },
    TeamPageModel: { getTemplate },
  } = useStore()
  const isMobile = width > 0 && width < BreakPoints.tablet

  const heroTitle =
    getTemplate("about.hero.title", false) ||
    'All about <span class="text-red-300 line-through">us</span><br/>Your Pleasure'
  const heroDescription =
    getTemplate("about.hero.description") ||
    "Own who you are, say what you’re into, and meet people who want the same. That’s Pure."

  return (
    <section
      className="relative w-full bg-no-repeat bg-cover bg-center mb-[150px] tablet:mb-[100px]"
      style={{
        backgroundImage: `url(${
          isMobile ? HeroSectionBgMobile.src : HeroSectionBg.src
        })`,
      }}
    >
      <div className="flex flex-col-reverse laptop:flex-col relative max-w-screen-desktop-l w-full h-[500px] desktop:h-[710px] desktop:pb-[250px] laptop:pt-[120px] px-[23px] desktop:px-[108px] laptop:px-[60px] mx-auto">
        <div className="absolute bottom-[-70px] tablet:relative z-1 h-fit w-fit tablet-lg:mt-0">
          <div className="mb-[24px] laptop:mb-[53px] rotate-[-4deg] leading-[48px] tablet:leading-[64px] font-pure text-[36px] tablet:text-[64px]">
            {parse(heroTitle)}
          </div>
          <div className=" laptop:ml-[20px] w-[320px] mobile-l:w-[380px] desktop:ml-[30px] font-sans text-[16px] tablet:text-[24px] leading-[20px] tablet:leading-[32px] rotate-[-3deg]">
            {parse(heroDescription)}
          </div>
        </div>
        <div className="absolute z-1 -top-[130px] desktop:-top-[185px] laptop:-top-[130px] -right-[310px] desktop:-right-[408px] laptop:-right-[310px] pointer-events-none select-none">
          <img
            src={HeroSectionIllustration.src}
            alt="Illustration"
            className="hidden tablet:block max-w-none w-[697px] laptop:w-[900px] desktop:w-[1227px] h-auto"
          />
          <img
            src={HeroSectionIllustrationMobile.src}
            alt="Illustration"
            className="block tablet:hidden max-w-none w-[697px] laptop:w-[900px] desktop:w-[1227px] h-auto"
          />
        </div>
      </div>
      <HeroSectionBottomBgMobile
        viewBox="0 0 375 224"
        className="block tablet:hidden absolute bottom-[-1px] right-0 w-full pointer-events-none select-none"
      />
      <HeroSectionBottomBg
        viewBox="0 0 1440 421"
        className="hidden tablet:block absolute bottom-[-1px] right-0 w-full pointer-events-none select-none"
      />
    </section>
  )
}

const HeroComponent = observer(Hero)
export { HeroComponent }
